import { __require as r } from "./Errors.mjs";
var e, a;
function s() {
  if (a) return e;
  a = 1;
  const s = r();
  return e = class {
    constructor(r) {
      this.sender = r;
    }
    send(r) {
      return new Promise((e, a) => {
        this.sender.send(r).then(e).catch(r => {
          switch (r.statusCode) {
            case 500:
              r.error = new s.InternalServerError();
              break;
            case 503:
              r.error = new s.ServiceUnavailableError();
              break;
            case 504:
              r.error = new s.GatewayTimeoutError();
              break;
            default:
              r.error = new s.DefaultError(r && r.payload && r.payload.errors[0] && r.payload.errors[0].message);
          }
          a(r);
        });
      });
    }
  };
}
export { s as __require };